import { mainReducer, mainRouter, mainSaga } from 'apps/services';
import configureStore from '../store/configureStore';

export default () => {
  let configs = {
    store: {},
    routes: {},
  };

  configs.store = configureStore(mainReducer, mainSaga);
  configs.routes = mainRouter(configs.store);

  return configs;
};
